"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderNameContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const constants_1 = require("../../lib/constants");
exports.ProviderNameContainer = styled_1.default.h1 `
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_3')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};

  @media screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_2')};
  }

  @media screen and (min-width: ${constants_1.BREAKPOINTS.medium}px) {
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_1')};
  }
`;
//# sourceMappingURL=provider-name.styles.js.map